import ImagesLoaded from 'imagesloaded'
import UAParser from 'ua-parser-js'

import slickFade from './lib/slick-fade'

import 'jquery-bridget'
import 'bootstrap-sass/assets/javascripts/bootstrap/collapse'
import 'bootstrap-sass/assets/javascripts/bootstrap/dropdown'
import 'bootstrap-sass/assets/javascripts/bootstrap/modal'
import 'bootstrap-sass/assets/javascripts/bootstrap/transition'
import 'bootstrap-hover-dropdown'
import 'slick-carousel'

import './lib/scrollchecker.js'
import './lib/tewrap.js'

// make Masonry and imagesLoaded jQuery plugin
ImagesLoaded.makeJQueryPlugin($)

// `ua-parser-js`でIEの時には`html`要素に`.ie`が付くようにした。
// `ie9`の場合はHTMLのコンディションコメントで`.ie9`が有効になる
var ieAddClass = function () {
  const uaParser = new UAParser()
  const uaResult = uaParser.getResult()
  const uaBrowser = uaResult.browser.name
  //
  if (uaBrowser === 'IE') {
    $('html').addClass('ie')
  }
}

// bogoの言語切り換えボタンのカスタマイズ
var languageSwitcher = function () {
  var $bogoLang = $('.bogo-language-switcher')
  $bogoLang.find('.en a').text('ENG')
  $bogoLang.find('.ja a').text('JPN')
  $bogoLang.css({
    'display': 'block'
  })
  $bogoLang.find('li').css({
    'display': 'none'
  })
  $bogoLang.find('a')
    .css({
      'display': 'block'
    })
    .parent('li')
    .css({
      'display': 'block'
    })
}

ieAddClass()

languageSwitcher()

slickFade()

$('.js-imagesLoaded').imagesLoaded(function () {
  $('.js-imagesLoaded').addClass('in')
})

// bootstrapのdropdownをhoverで開くようにするプラグイン
$('.ty-Dropdown-toggle').dropdownHover({
  delay: '',
  instantlyCloseOthers: '',
  hoverDelay: ''
})

// モバイル時のみ電話番号にリンクをラップするプラグイン
$('.js-tel-party').tewrap({
  phoneNumber: '03-5479-0776'
})

$('.js-tel-tyharbor').tewrap({
  phoneNumber: '03-5479-4555'
})

$('.js-tel-pr').tewrap({
  phoneNumber: '080-2567-9155'
})

// PDFファイルへのリンクに`target='_blank'`を追加
$('.p-menu a[href$="pdf"]').attr('target', '_blank')

// 指定の場所までスクロールしたらその要素にクラスを付けるプラグイン
// 下層ページ共通(tysons & restraurants)
$('.js-scrollchecker').scrollchecker({
  fixedPosition: $('.js-scrollchecker').height(),
  fixedClass: 'is-fixed',
  fixedAfterClass: 'is-fixed-after'
})

// スライドのプラグイン
$('.js-slickFull').slick({
  infinite: true,
  dots: true,
  // centerMode: true,
  variableWidth: true,
  speed: 300,
  arrows: true,
  responsive: [{
    breakpoint: 767,
    settings: {
      infinite: false,
      variableWidth: false
    }
  }]
})

$('.js-slickMasthead').slick({
  arrows: false,
  autoplay: true,
  autoplaySpeed: 3000,
  centerMode: true,
  dots: false,
  fade: true,
  slidesToShow: 1,
  speed: 1500
})

$(window).load(function () {})

$(window).resize(function () {})



// WEBPACK FOOTER //
// ./src/js/app.js